/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-04-27 19:04:42
 * @LastEditors: linxi
 * @LastEditTime: 2025-07-22 09:53:44
 */
import React, { useEffect, useState } from 'react'
import { Button, Col, Form, Input, Row, Select, Space } from 'antd'
const { Option } = Select
import { SearchOutlined, CaretDownFilled } from '@ant-design/icons'
import { useDispatch, useSelector } from 'react-redux'
import {
  pageDurgsystem,
  selectDurgsystemData,
} from '../durgsystem/durgsystemSlice'
import { pageSupplier } from '../wms/supplierSlice'
import {
  DepartmentDate,
  pagePutstorageUser,
  selectDepartData,
  selectPutstorageUser,
  setCategory,
  setCurrent,
} from '../putstorage/putstorageSlice'
import { putStorePageParams } from '../../services/putstorage'
import { DateRangeFieldName, DateSelect } from '../../compnents/form/DateSelect'
import { sleectUserData } from '../putstorelist/putstorelistSlice'
import { User } from '../../models/user'
import { getStorehouseTagName, StorehouseTags } from '../../models/category'
import styles from '../putstorage/putstorage.module.css'
import { useLocation } from 'react-router-dom'

export const uploadOptions = [
  {
    value: 1,
    label: '已上传',
  },
  {
    value: 0,
    label: '未上传',
  },
]

export const InventoryCheckingQuery = (props: {
  loading?: any
  YBUploadType?: boolean
  onValueChange: (queries: putStorePageParams) => void
  massUpload: () => void
}) => {
  const [form] = Form.useForm()

  const dispatch = useDispatch()

  const location: any = useLocation()

  const userData = useSelector(sleectUserData)

  const departmentData = useSelector(selectDepartData)

  const durgData = useSelector(selectDurgsystemData)

  // const putstorageUser = useSelector(selectPutstorageUser);

  const storageParams = JSON.parse(
    sessionStorage.getItem(
      location.pathname + '_' + location?.state?.category
    ) || '{}'
  )

  useEffect(() => {
    dispatch(pageDurgsystem(1, 100, 1))
    dispatch(pageSupplier({ current: 1, size: 10, supplierCategory: 0 }))
    dispatch(DepartmentDate({ current: 1, size: 1000 }))
    // dispatch(pagePutstorageUser({ current: 1, size: 1000 }));
  }, [])

  // useEffect(() => {
  // const userData = JSON.parse(JSON.stringify(putstorageUser));
  // const data = userData.filter((v: any, i: any, userData: any[]) => {
  //   return userData.findIndex((item) => item.userName === v.userName) === i;
  // });
  // setuserdata(data);
  // }, [putstorageUser]);

  useEffect(() => {
    if (location?.state?.category == '8') {
      if (Object.keys(storageParams).length) {
        form.setFieldsValue({
          ...storageParams,
        })
      }
      form.submit()
    }
  }, [])

  const refresh = () => {
    if (location?.state?.category == '8') {
      props.onValueChange({
        ...storageParams,
        ...form.getFieldsValue(),
        recepitsDateStart: form.getFieldsValue().registrationTimeHead,
        recepitsDateEnd: form.getFieldsValue().registrationTimeTail,
        registrationTimeHead: null,
        registrationTimeTail: null,
        current: 1,
      })
    } else {
      props.onValueChange({
        ...form.getFieldsValue(),
        recepitsDateStart: form.getFieldsValue().registrationTimeHead,
        recepitsDateEnd: form.getFieldsValue().registrationTimeTail,
        registrationTimeHead: null,
        registrationTimeTail: null,
        current: 1,
      })
    }

    dispatch(setCurrent(1))
  }

  return (
    <Form
      form={form}
      name='control-hooks'
      onFinish={(fs) => {
        if (location?.state?.category == '8') {
          const data = storageParams
          props.onValueChange({
            ...data,
            ...fs,
          })
          dispatch(setCurrent(data.current || 1))
        } else {
          props.onValueChange({
            ...fs,
          })
          dispatch(setCurrent(1))
        }
      }}
    >
      <Row style={{ margin: '0 0 10px 0' }} justify='space-between'>
        <Space wrap={false}>
          <Form.Item name='allNum' noStyle>
            <Input
              placeholder='输入业务单号'
              allowClear
              prefix={<SearchOutlined />}
              onChange={refresh}
            />
          </Form.Item>
          <Form.Item name='storehouseId' noStyle>
            <Select
              placeholder='库房列表'
              allowClear
              showSearch
              dropdownClassName={styles.select}
              optionFilterProp='children'
              onChange={refresh}
              // suffixIcon={<CaretDownFilled />}
              onSelect={(key: any) => {
                dispatch(setCategory(key))
              }}
            >
              {durgData.map((v: any) => {
                return (
                  <Option value={v.id} key={v.id}>
                    {v.name}
                  </Option>
                )
              })}
            </Select>
          </Form.Item>
          <Form.Item name='departmentId' noStyle>
            <Select
              placeholder='业务部门'
              allowClear
              showSearch
              dropdownClassName={styles.select}
              optionFilterProp='children'
              onChange={refresh}
              // suffixIcon={<CaretDownFilled />}
            >
              {departmentData.map((v: any) => {
                return (
                  <Option value={v.id} key={v.id}>
                    {v.name}
                  </Option>
                )
              })}
            </Select>
          </Form.Item>
          <Form.Item name='userId' noStyle>
            <Select
              showSearch
              placeholder='业务人员'
              allowClear
              dropdownClassName={styles.select}
              onChange={refresh}
              // suffixIcon={<CaretDownFilled />}
            >
              {userData.map((v: User) => {
                return (
                  <Option value={v.id} key={v.id}>
                    {v.name}
                  </Option>
                )
              })}
            </Select>
          </Form.Item>
          {/* <Col span={2}>
          <Form.Item name="supplierId">
            <Select
              placeholder="对方单位"
              allowClear
              showSearch
              optionFilterProp="children"
            >
              {supplierData.map((v: any, i) => {
                return (
                  <Option value={v.id} key={v.id}>
                    {v.companyName}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>
        </Col> */}
          {!props.YBUploadType && (
            <Form.Item name='storehouseTag' noStyle>
              <Select
                placeholder='是否登账'
                allowClear
                // suffixIcon={<CaretDownFilled />}
                dropdownClassName={styles.select}
                onChange={refresh}
              >
                {StorehouseTags.map((v) => (
                  <Option value={v} key={v}>
                    {getStorehouseTagName(v)}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          )}
          {props.YBUploadType && (
            <Form.Item name='ybUploadFlag' noStyle>
              <Select
                placeholder='是否已上传'
                allowClear
                // suffixIcon={<CaretDownFilled />}
                dropdownClassName={styles.select}
                onChange={refresh}
              >
                {uploadOptions.map((v) => (
                  <Option value={v.value} key={v.value}>
                    {v.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          )}
          <Form.Item name='recepitsDateEnd' noStyle>
            <DateSelect
              placeholder='发生时间'
              style={{ width: '8.5rem' }}
              labelPrefix=''
              namePrefix='registrationTime'
              onChange={refresh}
            />
          </Form.Item>
          <Button
            loading={props?.loading}
            type='primary'
            style={{ marginRight: '10px' }}
            onClick={refresh}
          >
            查询
          </Button>
        </Space>
        <Space>
          {props.YBUploadType && (
            <Button type='primary' onClick={() => props.massUpload()}>
              批量上传
            </Button>
          )}
        </Space>
      </Row>
    </Form>
  )
}
